import { Injectable, inject } from '@angular/core';
import { AssetService, ModalService } from '@schenck/rotec-components';
import { switchMap } from 'rxjs/operators';
import { ToolingTaskInfo } from 'src/api';
import { TaskModalService } from 'src/components';
import { ToolingTaskService } from 'src/services';

@Injectable()
export class ToolingHistoryModalService extends TaskModalService<ToolingTaskInfo> {
  private readonly assetService = inject(AssetService);

  public tooling$ = this.task$.pipe(
    switchMap((task) => this.assetService.tooling$(task.toolingId))
  );
  public machines$ = this.assetService.machinesThatHaveTooling$(this.tooling$);
  public plants$ = this.assetService.plantsOfTooling$(this.tooling$);

  constructor() {
    const taskService = inject(ToolingTaskService);
    const modalService = inject(ModalService);

    super(taskService, modalService, null);
  }
}
